import { useMutation, useQueryClient } from "@tanstack/react-query";
import { editUserGroups } from "../services/editGroupService";

export const useEditGroup = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editUserGroups,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["listUser"] });
    },
    onError: (error) => {
      console.error("Failed to edit user groups:", error);
    },
  });
};